// @flow

// NOTE: This Flow module has a corresponding ambient TypeScript declaration in app/types/flow-modules.d.ts. Keep them in sync until this file is migrated to TypeScript.

import type {PaymentMethod} from '@tectonics/commons/new-payment-methods/payment-method';
import {
  DisplayCardBrands,
} from '@tectonics/look-and-feel/volcanes/pages/page-opened-payment/payment-method/payment-method-selector/payment-method-item/display-brands/display-card-brands';
import {creditCardOutgoingPaymentMapper} from '@tectonics/prs/credit-card';
import {
  CreditCardForm,
} from '@tectonics/look-and-feel/volcanes/pages/page-opened-payment/payment-method/credit-card-form';
import React from 'react';

export const CreditcardGuatemala: PaymentMethod = {
  code: 'creditcard',
  nameKey: 'volcanes.creditcard.name',
  placeOrderMessageKey: 'volcanes.creditcard.placeOrder',
  icons: <DisplayCardBrands />,
  outgoingPaymentMapper: creditCardOutgoingPaymentMapper,
  paymentMethodForm: <CreditCardForm />,
};
